module.exports = __webpack_public_path__ + "assets/angular-material.71dc5e6f.svg";